import { possivelJSON, getNumber } from '@/src/utils/Format'
import { minhaCarteira } from '@constants/URL'

export function resolveBudgetLimit(budget) {
  if (!budget || typeof budget !== 'object') {
    return 0
  }
  const val = budget.valor_orcado
  if (val === null || val === undefined || val === '') {
    return 0
  }
  const parsed = getNumber(String(val))
  return Number.isFinite(parsed) ? parsed : 0
}

export const CONNECTION_STATUS_LABELS = {
  WAITING_USER_INPUT: 'Aguardando autorização',
  SUCCESS: 'Conectado',
  UPDATED: 'Atualizado',
}

export const CONNECTION_STATUS_COLORS = {
  WAITING_USER_INPUT: 'warning',
  SUCCESS: 'success',
  UPDATED: 'success',
}

export const createPatrimonyGoalDialog = () => ({
  visible: false,
  patrimonyId: null,
  patrimonyIds: [],
  patrimonyName: '',
  goalId: null,
  percent: 100,
  goalLinkId: null,
  batch: false,
})

export const createAssetGoalDialog = () => ({
  visible: false,
  assetId: null,
  assetIds: [],
  assetName: '',
  goalId: null,
  percent: 100,
  goalLinkId: null,
  batch: false,
})

export const CATEGORY_TABLE_HEADERS = [
  { text: 'Nome', value: 'nome', sortable: false },
  {
    text: 'Ícone',
    value: 'icone',
    sortable: false,
    align: 'center',
    width: 80,
  },
  { text: 'Cor', value: 'cor', sortable: false },
  { text: 'Descrição', value: 'descricao', sortable: false },
  { text: '', value: 'actions', sortable: false, align: 'end', width: 80 },
]

export const SUBCATEGORY_TABLE_HEADERS = [
  { text: 'Nome', value: 'nome', sortable: false },
  { text: 'Categoria', value: 'nomeCategoria', sortable: false },
  { text: 'Descrição', value: 'descricao', sortable: false },
  { text: '', value: 'actions', sortable: false, align: 'end', width: 80 },
]

export const RULE_TABLE_HEADERS = [
  { text: 'Nome', value: 'name', sortable: false },
  { text: 'Palavras-chave', value: 'keywordsLabel', sortable: false },
  { text: 'Campo de busca', value: 'searchFieldLabel', sortable: false },
  { text: 'Categoria', value: 'category', sortable: false },
  { text: 'Subcategoria', value: 'subcategory', sortable: false },
  { text: '', value: 'actions', sortable: false, align: 'end', width: 80 },
]

export const HIERARCHICAL_CATEGORY_HEADERS = [
  { text: '', value: 'data-table-expand', sortable: false, width: 40 },
  { text: 'Categoria', value: 'name', sortable: false, width: '30%' },
  { text: 'Tipo', value: 'tipo', sortable: false, align: 'center', width: 90 },
  { text: 'Planejado', value: 'planned', sortable: false, align: 'right', width: 100 },
  { text: 'Gasto', value: 'spent', sortable: false, align: 'right', width: 100 },
  { text: 'Restante', value: 'remaining', sortable: false, align: 'right', width: 100 },
  { text: '', value: 'actions', sortable: false, align: 'end', width: 80 },
]

export const PATRIMONY_TABLE_HEADERS = [
  // AAWZ DS 2026 (densidade — 1 linha por registro): "Tipo" volta a ser
  // coluna própria (era subtítulo abaixo do nome, 2 linhas por registro),
  // mesmo padrão de "Classe" em ASSETS_TABLE_HEADERS.
  { text: 'Ativo', value: 'nome_ativo', sortable: false },
  { text: 'Tipo', value: 'tipo_ativo', sortable: false },
  { text: 'Valor de mercado', value: 'valor_mercado', sortable: false, align: 'end' },
  { text: 'Ações', value: 'action', sortable: false, align: 'end', width: 110 },
]

export const GOALS_TABLE_HEADERS = [
  { text: 'Objetivo', value: 'nome_objetivo', sortable: false },
  { text: 'Tipo', value: 'tipo', sortable: false },
  { text: 'Atual / Meta', value: 'valores', sortable: false, align: 'end' },
  { text: 'Progresso', value: 'progresso', sortable: false },
  { text: 'Prazo', value: 'prazo', sortable: false, align: 'end' },
  { text: 'Ações', value: 'action', sortable: false, align: 'end', width: 130 },
]

export const ASSETS_TABLE_HEADERS = [
  { text: 'Ativo', value: 'assetName', sortable: false },
  { text: 'Classe', value: 'classLabel', sortable: false },
  { text: 'Saldo', value: 'amountLabel', sortable: false, align: 'end' },
  {
    text: 'Participação',
    value: 'weightLabel',
    sortable: false,
    align: 'center',
  },
]

export const RECEITAS_DESPESAS_TABLE_HEADERS = [
  { text: 'Item', value: 'nome', sortable: false },
  { text: 'Tipo', value: 'tipoLabel', sortable: false },
  { text: 'Frequência', value: 'frequencyLabel', sortable: false },
  { text: 'Valor mensal', value: 'monthlyValueLabel', sortable: false, align: 'end' },
  { text: 'Ações', value: 'action', sortable: false, align: 'end', width: 90 },
]

// Filtros do BaseFilterMenu da aba Receitas/Despesas (mesmo padrão usado no
// resto do produto — ver src/components/_base-filter-menu.vue). Tipo e
// Status são eixos independentes: Tipo recorta Receita/Despesa, Status
// recorta por vigência (isReceitaDespesaExpired). "Status: Ativos" é o
// born-default — replica o comportamento anterior (viewFilter: 'ativos'),
// só quem quer auditar item encerrado muda pra "Expirados"/"Todos".
export const RECEITAS_DESPESAS_FILTERS = [
  {
    key: 'tipo',
    label: 'Tipo',
    type: 'select',
    cols: 12,
    default: 'todos',
    clearTo: 'todos',
    options: [
      { text: 'Todos', value: 'todos' },
      { text: 'Receitas', value: 'receita' },
      { text: 'Despesas', value: 'despesa' },
    ],
  },
  {
    key: 'status',
    label: 'Status',
    type: 'select',
    cols: 12,
    default: 'ativos',
    clearTo: 'ativos',
    options: [
      { text: 'Ativos', value: 'ativos' },
      { text: 'Expirados', value: 'expirados' },
      { text: 'Todos', value: 'todos' },
    ],
  },
]

export const OPEN_FINANCE_CONNECTIONS_TABLE_HEADERS = [
  { text: 'Instituição', value: 'institution', sortable: false },
  { text: 'Status', value: 'status', sortable: false },
  { text: 'Última sincronização', value: 'lastSyncLabel', sortable: false },
  { text: 'Atualizado em', value: 'updatedAtLabel', sortable: false },
  {
    text: 'Enviar ao Consolidador',
    value: 'sincronizaConsolidador',
    sortable: false,
    align: 'center',
    width: 170,
  },
  { text: '', value: 'actions', sortable: false, align: 'end', width: 120 },
]

export const normalizeConnectionStatus = (connection) =>
  String(
    (connection && (connection.execution_status || connection.status)) || ''
  ).toUpperCase()

export const normalizeConnectorId = (connection) =>
  (connection && connection.id) ||
  (connection && connection.connectorId) ||
  (connection && connection.external_id) ||
  (connection && connection.externalConnectorId) ||
  (connection && connection.external_connector_id) ||
  null

export const normalizeConnectionClientId = (connection, fallback = null) => {
  if (!connection) return fallback
  if (
    connection.id_cliente_app !== undefined &&
    connection.id_cliente_app !== null
  ) {
    return connection.id_cliente_app
  }
  if (connection.clientId !== undefined && connection.clientId !== null) {
    return connection.clientId
  }
  return fallback
}

export const normalizeConnectorMeta = (connection) => {
  const additionalData = (connection && connection.additional_data) || {}
  return {
    connectorInfo: additionalData.connector || {},
    updatedAt: additionalData.updatedAt || (connection && connection.updatedAt),
  }
}

export const normalizeConsentUrl = (connection) =>
  (connection && connection.consentUrl) ||
  (connection && connection.qrCodeUrl) ||
  (connection && connection.link_consent) ||
  ''

const formatNumericPercent = (value) => `${value.toFixed(2)}%`

export const formatAssetWeightValue = (value) => {
  if (value === undefined || value === null || value === '') return '—'
  if (typeof value === 'number') {
    return formatNumericPercent(Math.abs(value) <= 1 ? value * 100 : value)
  }
  if (typeof value !== 'string') return '—'
  const trimmed = value.trim()
  if (!trimmed) return '—'
  if (trimmed.includes('%')) return trimmed
  const parsed = Number(trimmed.replace(',', '.'))
  if (Number.isNaN(parsed)) return trimmed
  const normalized = Math.abs(parsed) <= 1 ? parsed * 100 : parsed
  return formatNumericPercent(normalized)
}

const buildAssetsAnalysisParams = (groupMode) =>
  [
    'report_parts=assets_statistics',
    `corretora=${encodeURIComponent('Todos')}`,
    `merge_assets_by_name=${groupMode}`,
    'group_assets_by=subclasse',
  ].join('&')

export const buildAssetsAnalysisUrl = ({ isClient, clientId, groupMode }) => {
  const params = buildAssetsAnalysisParams(groupMode)
  return isClient
    ? `${minhaCarteira.cliente.analise_portfolio}?${params}`
    : `${minhaCarteira.analise_portfolio}/${clientId}?${params}`
}

export const normalizeAssetsAnalysisResponse = (response) => {
  if (!response || response.status !== 200) {
    return null
  }
  const value = response.value || {}
  const assets = possivelJSON(value.assets_statistics) || {}
  if (Object.prototype.hasOwnProperty.call(assets, 'total_pl')) {
    const totalPl = assets.total_pl
    delete assets.total_pl
    assets.total_pl = totalPl
  }
  return {
    assets,
    referenceEnd: value.data_fim || '',
  }
}

/**
 * Verifica se um item de receita/despesa esperada está expirado.
 * Um item está expirado quando sua data_fim é anterior a hoje.
 * Items sem data_fim são considerados ativos (sem prazo definido).
 * @param {Object} item - Item com campo data_fim no formato DD/MM/YYYY
 * @returns {boolean} true se o item está expirado
 */
export function isReceitaDespesaExpired(item) {
  if (!item || !item.data_fim || typeof item.data_fim !== 'string') return false
  const parts = item.data_fim.split('/')
  if (parts.length !== 3) return false
  const end = new Date(parts[2] + '-' + parts[1] + '-' + parts[0])
  if (Number.isNaN(end.getTime())) return false
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return end < today
}

/**
 * Filtra items de receitas/despesas removendo os expirados.
 * @param {Array} items - Lista de items
 * @returns {Array} Items ativos (data_fim >= hoje ou sem data_fim)
 */
export function filterActiveReceitasDespesas(items) {
  if (!Array.isArray(items)) return []
  return items.filter(function (item) {
    return !isReceitaDespesaExpired(item)
  })
}
